import * as THREE from "three";
import { Button } from "./button";
import { LollipopHelper } from "./lollipop-helper";
import { EasingFunction } from "./easing-utils";


// button, but you can add a mesh that moves back and forth
export class PhysicalButton extends Button {
  private _graphics?: THREE.Object3D<THREE.Object3DEventMap>;

  private _offsetVector = new THREE.Vector3(-0.0015, 0, 0.0);
  private _graphicsStartPosition = new THREE.Vector3(0, 0, 0);
  private _graphicsEndPosition = new THREE.Vector3(0, 0, 0);

  private _pressSpeed = 40;

  private _pressPhase = 0;

  protected _pressDelay = 0.2;

  set graphics(graphics: THREE.Object3D) {
    this._graphics = graphics;
    this._graphicsStartPosition.copy(this._graphics.position);
    this._graphicsEndPosition.copy(this._graphics.position);
    this._graphicsEndPosition.add(this._offsetVector);

    // this.add(new LollipopHelper())
    // this._graphics.add(new THREE.AxesHelper(1))
  }

  set offset(offset: THREE.Vector3) {
    this._offsetVector.copy(offset);
    this._graphicsEndPosition.copy(this._graphicsStartPosition);
    this._graphicsEndPosition.add(this._offsetVector);
  }


  updateDelta(delta: number): void {
    super.updateDelta(delta);

    if (this._graphics){

      this._pressPhase += delta * this._pressSpeed * (this._isTouched ? 1 : -1);
      this._pressPhase = THREE.MathUtils.clamp(this._pressPhase, 0, 1);
      this._graphics.position.lerpVectors(this._graphicsStartPosition, this._graphicsEndPosition, EasingFunction.easeInOutCubic(this._pressPhase));
      // this._graphics.visible = this._isTouched;
      // console.log("graphics visible", this._graphics.visible);
    }
  }

}
